import React, { FC, Suspense } from "react"
import type { AnnotationViewerProps } from "resha"
import { ErrorBoundary } from "../ErrorBoundary/ErrorBoundary"

const ReshaAnnotationViewer = React.lazy(async () => {
    return import("resha").then(resha => ({ default: resha.AnnotationViewer }))
})

export const AnnotationViewer: FC<
    AnnotationViewerProps & { fallback: JSX.Element }
> = ({ fallback, ...props }) => {
    return (
        <ErrorBoundary message="Could not render data">
            <Suspense fallback={fallback}>
                <ReshaAnnotationViewer {...props} />
            </Suspense>
        </ErrorBoundary>
    )
}
